var _rect, _rect2, _rect3, _path, _text, _text2, _rect4, _circle, _text3, _text4, _rect5, _circle2, _text5, _text6, _rect6, _circle3, _text7, _text8, _rect7, _circle4, _text9, _text0, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreVehicleRegistrationBaselineInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 440,
    viewBox: "0 0 620 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore vehicle baseline interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 440,
    rx: 30,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 618,
    height: 438,
    rx: 29,
    fill: "none",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 74,
    height: 74,
    rx: 19,
    fill: "#EAF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 72h33M54 58h23M60 48h11",
    stroke: "#087CFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 124,
    y: 55,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 800,
    textAnchor: "start",
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 124,
    dy: 0
  }, "VEHICLE BASELINE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 124,
    y: 87,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 800,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 124,
    dy: 0
  }, "FC\u20132047 \xB7 White panel van"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 126,
    width: 564,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 153,
    r: 7,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 158,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Registration evidence")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 158,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "Structured")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 194,
    width: 564,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 221,
    r: 7,
    fill: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 226,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Vehicle photo set")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 226,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "12 / 12 captured")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 262,
    width: 564,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 289,
    r: 7,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 294,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Opening odometer")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 294,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "51 284 km")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 330,
    width: 564,
    height: 54,
    rx: 13,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 357,
    r: 7,
    fill: "#FF2775"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 362,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Condition baseline")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 566,
    y: 362,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "Ready for review")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 402,
    width: 564,
    height: 10,
    rx: 5,
    fill: "#DFEAF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 402,
    width: 515,
    height: 10,
    rx: 5,
    fill: "#087CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreVehicleRegistrationBaselineInterface);
export default __webpack_public_path__ + "static/media/fleetcore-vehicle-registration-baseline-interface.d91f98d853fd2f3d6f54e0eb37043031.svg";
export { ForwardRef as ReactComponent };